"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_mobile.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function MobileVideoBuilder() {
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-video-builder"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-video-builder__change-screen"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mobile-video-builder__change-screen__icons"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "computer",
      color: "white",
      size: 75
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "tablet",
      color: "white",
      size: 40
    })), /*#__PURE__*/_react.default.createElement("p", null, 'You can only arrange footage on devices with larger screens. Switch to ' + 'a different device.')))
  );
}

var _default = (0, _react.memo)(MobileVideoBuilder);

exports.default = _default;